import { useEffect, useState } from 'react';

let initialValue = typeof sessionStorage !== 'undefined' ? sessionStorage?.referral || '' : '';

export function useRewardful(): string {
  const [affiliate, setAffiliate] = useState(
    typeof sessionStorage !== 'undefined' ? sessionStorage?.referral || initialValue : initialValue,
  );

  useEffect(() => {
    let mounted = true;

    window.rewardful?.('ready', () => {
      if (window.Rewardful?.referral && mounted) {
        setAffiliate(window.Rewardful.referral);
      }

      initialValue = window?.Rewardful?.referral || '';
    });

    return () => {
      mounted = false;
    };
  }, []);

  return affiliate;
}
